import Crud from '../views/Veiculo/Table'
import Entity from '../views/Veiculo/Add'

let routes = {
    path: '/veiculos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/veiculos/add',
            name: 'NewVeiculo',
            component: Entity,
            meta: {
                pageTitle: 'Veiculos',
                breadcrumb: [
                    {
                        text: 'Veiculos',
                        active: false,
                        to: '/veiculos',
                    },
                    {
                        text: 'criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/veiculos/edit/:id?',
            name: 'EditVeiculo',
            component: Entity,
            meta: {
                pageTitle: 'Veiculos',
                breadcrumb: [
                    {
                        text: 'Veiculos',
                        active: false,
                        to: '/veiculos',
                    },
                    {
                        text: 'editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/veiculos',
            name: 'list-veiculos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Veiculos',
                breadcrumb: [
                    {
                        text: 'Veiculos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
